// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as CardComponent} from './Card.svg';

import Icon, { TIconProps } from '../Icon';

export const IconCard = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <CardComponent/>
  </Icon>
));
